const Heading = ({ title, subtitle }: { title: string; subtitle: string }) => {
  return (
    <div className='flex flex-col gap-2'>
      <h2 className='font-heading text-xl font-semibold'>{title}</h2>
      <p className='text-sm font-medium text-muted-foreground'>{subtitle}</p>
    </div>
  );
};

export default Heading;
